import React from 'react';
import { Typography, Card, Row, Col } from 'antd';
import Icon from '@/components/Icon';
import styles from './index.scss';

const { Title, Paragraph } = Typography;

const ServicePage: React.FC = () => {
  const services = [
    {
      icon: 'platform',
      title: '生活服务平台',
      desc: '为银行信用卡、借记卡客户提供生活服务平台建设及运营服务',
    },
    {
      icon: 'rights',
      title: '权益平台',
      desc: '为银行提供权益平台建设及运营服务，包括权益商城、积分商城等',
    },
    {
      icon: 'marketing',
      title: '营销平台',
      desc: '为银行提供营销平台建设及运营服务，包括精准营销、活动营销等',
    },
    {
      icon: 'service',
      title: '智能客服',
      desc: '为银行提供智能客服系统建设及运营服务，包括智能语音、智能文本等',
    },
  ];

  const solutions = [
    {
      title: '金融科技解决方案',
      subtitle: 'FinTech Solutions',
      desc: '为银行、保险、证券等金融机构提供全方位的数字化解决方案，包括智能营销、风控管理、客户服务等多个领域。',
      features: [
        '智能营销系统',
        '风险控制平台',
        '客户服务中心',
        '数据分析平台',
      ],
    },
    {
      title: '数字化转型服务',
      subtitle: 'Digital Transformation',
      desc: '帮助传统企业实现数字化转型，提供从咨询规划到落地实施的全流程服务。',
      features: [
        '数字化战略咨询',
        '业务流程重构',
        '技术架构升级',
        '数据治理方案',
      ],
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.services}>
        <Title level={2} className={styles.sectionTitle}>
          我们的服务
        </Title>
        <Row gutter={[24, 24]}>
          {services.map((service, index) => (
            <Col xs={24} sm={12} md={6} key={index}>
              <Card className={styles.serviceCard} bordered={false}>
                <div className={styles.iconWrapper}>
                  <Icon name={service.icon} size={32} />
                </div>
                <Title level={4}>{service.title}</Title>
                <Paragraph>{service.desc}</Paragraph>
              </Card>
            </Col>
          ))}
        </Row>
      </div>

      <div className={styles.solutions}>
        <Title level={2} className={styles.sectionTitle}>
          解决方案
        </Title>
        <Row gutter={[24, 24]}>
          {solutions.map((solution, index) => (
            <Col xs={24} md={12} key={index}>
              <Card className={styles.solutionCard} bordered={false}>
                <Title level={3}>{solution.title}</Title>
                <div className={styles.subtitle}>{solution.subtitle}</div>
                <Paragraph>{solution.desc}</Paragraph>
                <ul className={styles.features}>
                  {solution.features.map((feature, i) => (
                    <li key={i}>{feature}</li>
                  ))}
                </ul>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};

export default ServicePage;
